var render, staticRenderFns
import script from "./mangaKuBaseLogic.vue?vue&type=script&lang=js&"
export * from "./mangaKuBaseLogic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69593aa8",
  null
  
)

export default component.exports